import React, {useEffect} from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {useAuth} from "../../context/AuthContext";
import HeaderSubPageTiny from "../partial/HeaderSubPageTiny";

const Logout = () => {
    const auth = useAuth();

    useEffect(() => {
        auth.logOut()
    }, [])

    return (
        <div className="site wrapper-content">
            <HeaderSubPageTiny title={'Kontakt'} subtitle={'SO ERREICHEN SIE UNS'}
                               bgImage={Image}></HeaderSubPageTiny>
            <section className="content-area">
                <div className="container">

                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="card border border-light-subtle rounded-3 shadow-sm">
                                <div className="card-body p-3 p-md-4 p-xl-5">
                                    <h2 className="mb-4 text-center">Sie haben sich erfolgreich ausgeloggt.</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Logout;